export enum CALENDAR_DIRECTIONS {
    LEFT = 'left',
    RIGHT = 'right',
    NEXT = 'next',
    PREV = 'prev',
  }
